import { handleJsonResponse } from "./generic";

export const fetchCheckerMetadata = (successCallback, errorCallback) => {
  fetch(`/api/pycheck/metadata`).then((response) =>
    handleJsonResponse(response, successCallback, errorCallback)
  );
};
